import { Component, OnInit, OnDestroy, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { forkJoin } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// dashboard-site.module.ts (ou o nome do seu módulo de recursos)
import { NgxChartsModule } from '@swimlane/ngx-charts';


@Component({
    selector: 'app-dashboard-site-graficos-page',
    templateUrl: './dashboard-site-graficos-page.component.html',
    styleUrls: ['./dashboard-site-graficos-page.component.css']
})
export class DashboardSiteGraficoPageComponent implements OnInit, OnDestroy {

    public site: any;
    public realTimeCards: any[] = [];
    public charts: any[] = [];
    public pageTitle: string = '';

    // --- Variáveis dos Gráficos ---
    public graficosRenderizados: any[] = [];
    public dadosOriginaisAPI: any[] = []; // Centralizamos os dados brutos aqui

    // --- Variáveis do Filtro ---
    public dataInicio: string = '';
    public dataFim: string = '';
    public exibirComparativo: boolean = false; // Valor padrão como 'Sim'
    // Configurações do gráfico
    public view: any[] = [700, 400];
    public dataReferencia: string = '';
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;
    private isMobile: boolean = false;

    constructor(
        private route: ActivatedRoute,
        public authenticationService: AuthenticationService,
        private sitesService: SitesService,
        private dataService: DataService,
        private spinner: NgxSpinnerService,
        private breakpointObserver: BreakpointObserver,
    ) { }

    ngOnInit() {
        this.breakpointObserver.observe([
            Breakpoints.Handset, // Detecta celulares (geralmente < 600px)
            '(max-width: 768px)' // Opcional: força o seu breakpoint de 768px
        ]).subscribe(result => {
            this.isMobile = result.matches;
            //this.atualizarDadosGraficos(); // Função para filtrar os dados
        });
        if (this.isMobile) {
            this.exibirComparativo = false;
        } else {
            this.exibirComparativo = true;
        }
        this.route.params.subscribe(params => {
            // --- NOVO: Pega exatamente o dia de hoje ---
            const dataAtual = new Date();

            // Formata a data de hoje para o padrão YYYY-MM-DD
            const dataHojeFormatada = this.formatarDataParaInput(dataAtual);

            // Preenche o Início e o Fim com o dia corrente!
            this.dataInicio = dataHojeFormatada;
            this.dataFim = dataHojeFormatada;

            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;
                const configuracoes = this.site.siteGraficos;

                if (configuracoes && configuracoes.length > 0) {

                    // 1. Cria o array de requisições
                    const requisicoesDados = configuracoes.map(config =>
                        this.sitesService.GetDadosPorTag(config.categoriaGrafico, config.tagEPM)
                    );

                    // 2. Executa o forkJoin corretamente
                    forkJoin(requisicoesDados).subscribe((listaDeResultados: any[]) => {

                        // 3. Salva a resposta intocável da API (antes do filtro)
                        this.dadosOriginaisAPI = listaDeResultados;

                        // 4. Chama a função que processa, aplica os filtros (se houver) e desenha o gráfico
                        this.renderizarGraficos();

                        this.spinner.hide();
                    }, error => {
                        console.error("Erro ao buscar dados dos gráficos", error);
                        this.spinner.hide();
                    });

                } else {
                    this.spinner.hide(); // Esconde se não houver configurações
                }
            }, error => {
                console.error("Erro ao buscar site", error);
                this.spinner.hide();
            });
        });
    }

    formatarDataParaInput(data: Date): string {
        const ano = data.getFullYear();
        const mes = ('0' + (data.getMonth() + 1)).slice(-2); // Adiciona o zero à esquerda
        const dia = ('0' + data.getDate()).slice(-2);        // Adiciona o zero à esquerda
        return `${ano}-${mes}-${dia}`;
    }

    renderizarGraficos() {
        const configuracoes = this.site.siteGraficos;
        var dataFimTime
        var dataInicioTime
        var dInicio
        var dataFimAnterior
        var dataInicioTimeAnterior
        var partes
        // 1. Criamos os dados em uma variável temporária
        const novaListaRenderizada = configuracoes.map((config, index) => {
            let dataInicioFiltro: number;
            const dataReferenciaTime = new Date(this.dataFim + 'T23:59:59').getTime();
            if (config.categoriaGrafico === 'DI') {
                // Lógica DIÁRIO (Barras): Pega do dia 01 do mês até a Data de Referência
                partes = this.dataFim.split('-'); // [YYYY, MM, DD]
                const primeiroDiaDoMes = `${partes[0]}-${partes[1]}-01`;
                dataInicioTime = new Date(primeiroDiaDoMes + 'T00:00:00').getTime();
                dataFimTime = new Date(this.dataFim + 'T23:00:00').getTime();

                const dtAnterior = new Date(partes[0], parseInt(partes[1]) - 1, 15);
                dtAnterior.setMonth(dtAnterior.getMonth() - 1); // Retrocede 1 mês exato
                const anoAnt = dtAnterior.getFullYear();
                const mesAnt = ('0' + (dtAnterior.getMonth() + 1)).slice(-2);

                const primeiroDiaMesAnterior = `${anoAnt}-${mesAnt}-01`;
                const ultimoDiaMesAnterior = `${anoAnt}-${mesAnt}-${partes[2]}`; // Vai até o mesmo dia do mês anterior
                dataInicioTimeAnterior = new Date(primeiroDiaMesAnterior + 'T00:00:00').getTime();
                dataFimAnterior = new Date(ultimoDiaMesAnterior + 'T23:00:00').getTime();
            } else {

                // Lógica HORÁRIO (Linhas): Pega apenas o dia da Data de Referência
                dataFimTime = new Date(this.dataFim + 'T23:00:00').getTime();
                dataInicioTime = new Date(this.dataFim + 'T00:00:00').getTime();
                const dt = new Date(this.dataFim + 'T12:00:00');
                dt.setDate(dt.getDate() - 1);
                dInicio = this.formatarDataParaInput(dt);
                dataFimAnterior = new Date(dInicio + 'T23:00:00').getTime();
                dataInicioTimeAnterior = new Date(dInicio + 'T00:00:00').getTime();
            }

            // 💡 TRUQUE 1: Copiamos o array original (evita bagunçar a memória)
            let dadosBrutos = [...this.dadosOriginaisAPI[index]];
            var dadosBrutosAnterior = [];

            if (this.exibirComparativo) {
                dadosBrutosAnterior = [...this.dadosOriginaisAPI[index]];
            }

            // Se o usuário preencheu as duas datas, nós filtramos o array!
            if (this.dataInicio && this.dataFim) {
                //const dataInicioTime = new Date(this.dataInicio + 'T00:00:00').getTime();
                //const dataFimTime = new Date(this.dataFim + 'T23:59:59').getTime();

                dadosBrutos = dadosBrutos.filter(d => {
                    const dataMedicaoTime = new Date(d.data + 'T' + d.hora).getTime();
                    return dataMedicaoTime >= dataInicioTime && dataMedicaoTime <= dataFimTime;
                });

                dadosBrutosAnterior = dadosBrutosAnterior.filter(d => {
                    const dataMedicaoTime = new Date(d.data + 'T' + d.hora).getTime();
                    return dataMedicaoTime >= dataInicioTimeAnterior && dataMedicaoTime <= dataFimAnterior;
                });
            }
            // 2. ORDENAÇÃO (NOVO): Ordena por Data e Hora de forma crescente (mais antigo > mais novo)
            dadosBrutos.sort((a, b) => {
                const dataA = new Date(a.data + 'T' + a.hora).getTime();
                const dataB = new Date(b.data + 'T' + b.hora).getTime();
                return dataA - dataB; // Se quiser decrescente, é só inverter para dataB - dataA
            });

            // 2. ORDENAÇÃO (NOVO): Ordena por Data e Hora de forma crescente (mais antigo > mais novo)
            dadosBrutosAnterior.sort((a, b) => {
                const dataA = new Date(a.data + 'T' + a.hora).getTime();
                const dataB = new Date(b.data + 'T' + b.hora).getTime();
                return dataA - dataB; // Se quiser decrescente, é só inverter para dataB - dataA
            });

            return {
                config: config,
                // 💡 TRUQUE 2: Forçamos uma NOVA referência no array que vai para o HTML
                dados: [...this.formatarParaNgxCharts(config, dadosBrutos, dadosBrutosAnterior)]
            };
        });

        // 💡 TRUQUE 3: Atualizamos a variável global clonando a lista inteira.
        // Isso dispara o gatilho visual do Angular e do ngx-charts!
        this.graficosRenderizados = [...novaListaRenderizada];

        console.log("DADOS RENDERIZADOS:", this.graficosRenderizados);
    }

    aplicarFiltro() {
        // Colocamos o log aqui para você ter certeza que a data está vindo do HTML
        console.log("Data Início:", this.dataInicio);
        console.log("Data Fim:", this.dataFim);

        if (!this.dataInicio || !this.dataFim) {
            alert('Por favor, selecione a data de início e fim.');
            return;
        }

        // Refaz os gráficos com o novo filtro
        this.renderizarGraficos();
    }
    formatarParaNgxCharts(config: any, dadosBrutos: any[], dadosBrutosAnterior: any[] = []) {
        const converter = (v) => typeof v === 'string' ? parseFloat(v.replace(',', '.')) : v;
        var diaAtual
        if (config.tipoGrafico === 'BA') {
            const datasDiferentes = new Set(dadosBrutos.map(d => d.data)).size > 1;
            const resultadoAgrupado = [];
            if (datasDiferentes) {

                const diasUnicos = Array.from(new Set([
                    ...dadosBrutos.map(d => d.data.split('-')[2]),
                    ...dadosBrutosAnterior.map(d => d.data.split('-')[2])
                ])).sort();

                diasUnicos.forEach(dia => {
                    const registroAnt = dadosBrutosAnterior.find(d => d.data.split('-')[2] === dia);
                    const registroAtu = dadosBrutos.find(d => d.data.split('-')[2] === dia);
                    if (this.exibirComparativo) {
                        resultadoAgrupado.push({
                            name: dia,
                            series: [
                                { name: 'Mês Atual', value: registroAtu ? converter(registroAtu.valor) : 0 },
                                { name: 'Mês Anterior', value: registroAnt ? converter(registroAnt.valor) : 0 }
                            ]
                        });
                    } else {
                        resultadoAgrupado.push({
                            name: dia,
                            series: [
                                { name: 'Mês Atual', value: registroAtu ? converter(registroAtu.valor) : 0 }
                            ]
                        });
                    }
                });
                // return resultadoAgrupado;
            } else {
                // Lógica por HORA (Dia Atual vs Dia Anterior) - IGUAL AO GRÁFICO DE LINHA
                // Pegamos todas as horas presentes nos dois arrays
                const horasUnicas = Array.from(new Set([
                    ...dadosBrutos.map(d => d.hora),
                    ...dadosBrutosAnterior.map(d => d.hora)
                ])).sort();

                horasUnicas.forEach(hora => {
                    const labelHora = this.formatHora(hora);
                    const registroAnt = dadosBrutosAnterior.find(d => d.hora === hora);
                    const registroAtu = dadosBrutos.find(d => d.hora === hora);

                    const series = [{ name: 'Dia Atual', value: registroAtu ? converter(registroAtu.valor) : 0 }];
                    if (this.exibirComparativo) {
                        series.push({ name: 'Dia Anterior', value: registroAnt ? converter(registroAnt.valor) : 0 });
                    }

                    resultadoAgrupado.push({ name: labelHora, series: series });
                });
            }
            return resultadoAgrupado;
        } else {
            // --- LÓGICA DE LINHA (LI) ---
            // Verificamos se os dados são Diários (BA-like) ou Horários baseando-se na configuração ou nos dados
            // Se houver datas diferentes no array, tratamos como Diário.
            const datasDiferentes = new Set(dadosBrutos.map(d => d.data)).size > 1;

            if (datasDiferentes) {
                // VISÃO DIÁRIA NO GRÁFICO DE LINHA
                const diasUnicos = Array.from(new Set([
                    ...dadosBrutos.map(d => d.data.split('-')[2]),
                    ...dadosBrutosAnterior.map(d => d.data.split('-')[2])
                ])).sort();
                if (this.exibirComparativo) {
                    return [

                        {
                            name: 'Mês Atual',
                            series: diasUnicos.map(dia => {
                                const reg = dadosBrutos.find(d => d.data.split('-')[2] === dia);
                                return { name: dia, value: reg ? converter(reg.valor) : 0 };
                            })
                        }, {
                            name: 'Mês Anterior',
                            series: diasUnicos.map(dia => {
                                const reg = dadosBrutosAnterior.find(d => d.data.split('-')[2] === dia);
                                return { name: dia, value: reg ? converter(reg.valor) : 0 };
                            })
                        }
                    ];
                } else {
                    return [
                        {
                            name: 'Mês Atual',
                            series: diasUnicos.map(dia => {
                                const reg = dadosBrutos.find(d => d.data.split('-')[2] === dia);
                                return { name: dia, value: reg ? converter(reg.valor) : 0 };
                            })
                        }
                    ];
                }
            } else {
                if (this.exibirComparativo) {
                    // VISÃO HORÁRIA (Sua lógica original que já funcionava)
                    return [
                        {
                            name: 'Dia Atual',
                            series: dadosBrutos.map(d => ({ name: this.formatHora(d.hora), value: converter(d.valor) }))
                        },
                        {
                            name: 'Dia Anterior',
                            series: dadosBrutosAnterior.map(d => ({ name: this.formatHora(d.hora), value: converter(d.valor) }))
                        }

                    ];
                } else {
                    return [
                        {
                            name: 'Dia Atual',
                            series: dadosBrutos.map(d => ({ name: this.formatHora(d.hora), value: converter(d.valor) }))
                        }
                    ];
                }
            }


            // return [
            //     {
            //         name: 'Dia Anterior',
            //         series: dadosBrutosAnterior.map(d => ({
            //             name: d.hora, // O nome (Eixo X) deve ser igual em ambas para alinhar
            //             value: converter(d.valor)
            //         }))
            //     },
            //     {
            //         name: 'Dia Atual',
            //         series: dadosBrutos.map(d => ({
            //             name: d.hora,
            //             value: converter(d.valor)
            //         }))
            //     }
            // ];
        }
    }
    // formatarParaNgxCharts(config: any, dadosBrutos: any[]) {
    //     const converter = (v) => typeof v === 'string' ? parseFloat(v.replace(',', '.')) : v;

    //     if (config.tipoGrafico === 'BA') { // Barra / Diário
    //         return dadosBrutos.map(d => ({
    //             name: d.data,
    //             value: converter(d.valor)
    //         }));
    //     } else { // Linha / Horário (LI)
    //         return [{
    //             name: config.nomeGrafico,
    //             series: dadosBrutos.map(d => ({
    //                 name: d.hora,
    //                 value: converter(d.valor)
    //             }))
    //         }];
    //     }
    // }

    ngOnDestroy() {
        if (this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if (this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    }

    refreshCardData() {
        let tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({ items: tags }).subscribe(response => {
            for (let i in response.data) {
                Object.assign(tags[i], response.data[i]);
            }
        });
    }

    refreshChartData() {
        this.charts.forEach(chart => {
            this.updateChart(chart);
        });
    }

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    }

    // Auxiliar para tratar a vírgula decimal (se necessário em outras rotinas)
    converterValor(valor: any): number {
        if (typeof valor === 'string') {
            return parseFloat(valor.replace(',', '.'));
        }
        return valor;
    }

    formatHora(val: string) {
        if (val.includes(':')) {
            return val.split(':')[0] + 'h';
        }
        return val;
    }
}